import { useEffect, useRef } from 'react';
import { logout } from '~/services/auth';
import Endpoints from '~/services/endpoints';
import Constants from '~/utils/constants';
import { useAuth } from './contexts/useAuth';
import useApi from './useApi';

const CHECK_INTERVAL = 5 * 60 * 1000;
const PUBLIC_PATHS = ['/', '/forgot', '/forgotNewPass'];

export const usePasswordExpiration = (pathname: string): void => {
  const { isAuthenticated } = useAuth();
  const authenticated = isAuthenticated();
  const { callApi } = useApi<boolean>(Endpoints.account.passwordExpired);
  const callApiRef = useRef(callApi);
  callApiRef.current = callApi;

  useEffect(() => {
    if (PUBLIC_PATHS.includes(pathname) || !authenticated) return undefined;

    const userId = localStorage.getItem(Constants.USER_ID);
    const sessionId = localStorage.getItem(Constants.SESSION_ID);
    if (!userId) return undefined;

    let active = true;
    let checking = false;
    const checkExpiration = async () => {
      if (!active || checking || !isAuthenticated()) return;
      checking = true;
      try {
        const response = await callApiRef.current();
        if (
          active &&
          response.success &&
          response.data === true &&
          localStorage.getItem(Constants.USER_ID) === userId &&
          localStorage.getItem(Constants.SESSION_ID) === sessionId
        ) {
          active = false;
          logout();
        }
      } catch (error) {
        console.error('Falha ao consultar expiracao da senha.', error);
      } finally {
        checking = false;
      }
    };

    checkExpiration();
    const timer = window.setInterval(checkExpiration, CHECK_INTERVAL);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [pathname, authenticated]);
};
